import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { palette } from "./styles";

interface PdfFooterProps {
  cityName: string;
}

const styles = StyleSheet.create({
  root: {
    position: "absolute",
    bottom: 24,
    left: 36,
    right: 36,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: palette.spacing.sm,
    borderTopWidth: 0.5,
    borderTopStyle: "solid",
    borderTopColor: palette.border,
  },
  wordmark: {
    fontSize: palette.type.small,
    fontFamily: "Helvetica-Bold",
    color: palette.brand,
  },
  center: {
    fontSize: palette.type.small,
    color: palette.muted,
  },
  pageNumber: {
    fontSize: palette.type.small,
    color: palette.muted,
    textAlign: "right",
  },
  sideSlot: {
    flexBasis: "33%",
  },
  centerSlot: {
    flexBasis: "33%",
    textAlign: "center",
  },
});

export function PdfFooter({ cityName }: PdfFooterProps) {
  return (
    <View style={styles.root} fixed>
      <View style={styles.sideSlot}>
        <Text style={styles.wordmark}>Equip Sport</Text>
      </View>
      <View style={styles.centerSlot}>
        <Text style={styles.center}>{cityName}</Text>
      </View>
      <View style={styles.sideSlot}>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
      </View>
    </View>
  );
}
